module.exports = __webpack_public_path__ + "img/献县扣件.f305327d.jpg";